var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(-61.049 0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    transform: "translate(61.049 -0.3)",
    fill: "#fff",
    stroke: " #1DA1F2 ",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M23.916,5.987a9.3,9.3,0,0,1-2.586.7A4.526,4.526,0,0,0,23.314,4.2a9,9,0,0,1-2.86,1.1,4.493,4.493,0,0,0-7.671,4.1,12.755,12.755,0,0,1-9.26-4.7,4.559,4.559,0,0,0-.6,2.268A4.482,4.482,0,0,0,4.915,10.7a4.438,4.438,0,0,1-2.038-.559v.055a4.493,4.493,0,0,0,3.616,4.383,4.307,4.307,0,0,1-1.205.186,5.369,5.369,0,0,1-.844-.077,4.5,4.5,0,0,0,4.2,3.112A9.008,9.008,0,0,1,3.1,19.728,8.69,8.69,0,0,1,2,19.663,12.679,12.679,0,0,0,8.893,21.69a12.7,12.7,0,0,0,12.832-12.8V8.31a9.238,9.238,0,0,0,2.192-2.323Z",
    transform: "translate(73.393 11.93)",
    fill: " #1DA1F2 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterShare);
export default __webpack_public_path__ + "static/media/twitter-share.44089def6f784f41fec04fac4ea46752.svg";
export { ForwardRef as ReactComponent };